import { Button, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import UpdatePayGatePaymentModuleForm, { type FormValues } from './UpdatePayGatePaymentModuleForm';

type UpdatePayGatePaymentModuleDrawerProps = {
    moduleId: string;
    initialValues: FormValues;
    visible: boolean;
    onClose: () => void;
};

const UpdatePayGatePaymentModuleDrawer = ({
    moduleId,
    initialValues,
    visible,
    onClose,
}: UpdatePayGatePaymentModuleDrawerProps) => {
    const { t } = useTranslation(['paygatePaymentModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>
                        {t('paygatePaymentModuleDetails:paymentModuleDrawer.cancelButton')}
                    </Button>
                    <Button form="updatePayGatePaymentModule" htmlType="submit" type="primary">
                        {t('paygatePaymentModuleDetails:paymentModuleDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('paygatePaymentModuleDetails:paymentModuleDrawer.title.update')}
            visible={visible}
            destroyOnClose
        >
            <UpdatePayGatePaymentModuleForm initialValues={initialValues} moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default UpdatePayGatePaymentModuleDrawer;

export const useUpdatePayGatePaymentModuleDrawer = (
    moduleId: string,
    initialValues: UpdatePayGatePaymentModuleDrawerProps['initialValues']
) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => (
            <UpdatePayGatePaymentModuleDrawer
                initialValues={initialValues}
                moduleId={moduleId}
                onClose={actions.close}
                visible={visible}
            />
        ),
    };
};
